import React from "react";
import { motion } from "framer-motion";
import heroImg from "../assets/swamy1.jpeg";

// Simple TextType component simulation
const TextType = ({ text, style, loop }) => {
  const [displayText, setDisplayText] = React.useState("");
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    if (index < text[0].length) {
      const timeout = setTimeout(() => {
        setDisplayText(prev => prev + text[0][index]);
        setIndex(index + 1);
      }, 75);
      return () => clearTimeout(timeout);
    }
  }, [index, text, loop]);

  return <div style={style}>{displayText}</div>;
};

export default function Hero() {
  const [language, setLanguage] = React.useState('tamil');

  React.useEffect(() => {
    const interval = setInterval(() => {
      setLanguage((prev) => (prev === 'tamil' ? 'english' : 'tamil'));
    }, 5000); // Switch every 5 seconds
    return () => clearInterval(interval);
  }, []);

  const content = {
    tamil: {
      header: "சிவ சிவம் நாராயணம்",
      title1: "ஸ்ரீமன் வைகுண்ட",
      title2: "நாராயணசுவாமி",
      title3: "திருக்கோவில்",
      subtitle: "(மதகநெல்லூர் என்ற மதகநேரி)"
    },
    english: {
      header: "Shiva Shivam Narayanam",
      title1: "Sriman Vaikunta",
      title2: "Narayanaswamy",
      title3: "Temple",
      subtitle: "(Madaganellur also known as Madaganeri)"
    }
  };

  const current = content[language];

  return (
    <header id="home" className="relative text-white py-24 md:py-36 overflow-hidden">
      {/* Animated Wave Background */}
      <div className="absolute inset-0 z-0">
        {/* Ocean gradient background */}
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900 via-blue-800 to-blue-950"></div>

        {/* Animated waves */}
        <svg className="absolute bottom-0 w-full h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <motion.path
            fill="#1e40af"
            fillOpacity="0.3"
            d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,144C960,149,1056,139,1152,128C1248,117,1344,107,1392,101.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            animate={{
              d: [
                "M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,144C960,149,1056,139,1152,128C1248,117,1344,107,1392,101.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
                "M0,128L48,138.7C96,149,192,171,288,165.3C384,160,480,128,576,112C672,96,768,96,864,106.7C960,117,1056,139,1152,138.7C1248,139,1344,117,1392,106.7L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
                "M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,144C960,149,1056,139,1152,128C1248,117,1344,107,1392,101.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
              ]
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
          <motion.path
            fill="#2563eb"
            fillOpacity="0.5"
            d="M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,144C672,128,768,128,864,138.7C960,149,1056,171,1152,170.7C1248,171,1344,149,1392,138.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            animate={{
              d: [
                "M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,144C672,128,768,128,864,138.7C960,149,1056,171,1152,170.7C1248,171,1344,149,1392,138.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
                "M0,192L48,197.3C96,203,192,213,288,208C384,203,480,181,576,170.7C672,160,768,160,864,165.3C960,171,1056,181,1152,186.7C1248,192,1344,192,1392,192L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
                "M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,144C672,128,768,128,864,138.7C960,149,1056,171,1152,170.7C1248,171,1344,149,1392,138.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
              ]
            }}
            transition={{
              duration: 10,
              repeat: Infinity,
              ease: "easeInOut",
              delay: 1
            }}
          />
          <motion.path
            fill="#3b82f6"
            fillOpacity="0.7"
            d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,213.3C672,224,768,224,864,213.3C960,203,1056,181,1152,181.3C1248,181,1344,203,1392,213.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            animate={{
              d: [
                "M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,213.3C672,224,768,224,864,213.3C960,203,1056,181,1152,181.3C1248,181,1344,203,1392,213.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
                "M0,256L48,245.3C96,235,192,213,288,213.3C384,213,480,235,576,240C672,245,768,235,864,229.3C960,224,1056,224,1152,229.3C1248,235,1344,245,1392,250.7L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
                "M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,213.3C672,224,768,224,864,213.3C960,203,1056,181,1152,181.3C1248,181,1344,203,1392,213.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
              ]
            }}
            transition={{
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut",
              delay: 2
            }}
          />
        </svg>

        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div style={{ textAlign: 'center', marginRight: '5rem' }}>
          <motion.div
            key={language + '-header'}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            style={{ fontSize: "2rem", fontWeight: "bold" }}
          >
            {current.header}
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 items-center gap-8">
          {/* TEXT SECTION - 8 Columns */}
          <div className="md:col-span-8">
            <motion.h1
              key={language}
              initial={{ y: 40, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              className="text-4xl mb-3 sm:text-5xl md:text-6xl lg:text-7xl font-bold text-left"
            >
              <span className="block leading-[5rem] drop-shadow-lg">{current.title1}</span>
              <span className="block leading-[6rem] text-orange-400 drop-shadow-lg">{current.title2}</span>
              <span className="block leading-[6rem] drop-shadow-lg">{current.title3}</span>
            </motion.h1>

            <motion.div
              key={language + '-subtitle'}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
              style={{ fontSize: "2rem", fontWeight: "bold" }}
            >
              {current.subtitle}
            </motion.div>
          </div>

          {/* IMAGE SECTION - 4 Columns */}
          <div className="md:col-span-4 flex justify-center md:justify-end">
            <motion.img
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.4, duration: 1 }}
              src={heroImg}
              alt="Narayanaswamy Temple"
              className="w-[280px] sm:w-[350px] md:w-[420px] lg:w-[480px] object-contain"
            />
          </div>
        </div>
      </div>
    </header>
  );
}